import { ComponentsProps } from '@material-ui/core/styles/props';

export const muiButtonProps = (): ComponentsProps => ({
  MuiButton: {
    disableElevation: true,
    color: 'primary',
    variant: 'contained',
    size: 'medium',
  },
});
